export const TAX_OPTIONS_CALCULATION_BASIS = [
  { label: "ICMS", value: "1" },
  { label: "PIS", value: "2" },
  { label: "COFINS", value: "3" },
  { label: "IBS", value: "6" },
  { label: "CBS", value: "7" },
];

export const columnTranslations: Record<string, string> = {
  state_id: "ID",
  state: "Estado",
  tip: "Tipo de Tributo",
  alq: "Alíquota",
  cst: "CST",
  cfop: "CFOP",
  classification_tax: "Classificação Tributária",
  created_at: "Criado Em",
  initial_term: "Data Inicial",
  final_term: "Data Final",
  status: "Status",
};

export const states = [
  { key: "AC", label: "AC" },
  { key: "AL", label: "AL" },
  { key: "AM", label: "AM" },
  { key: "AP", label: "AP" },
  { key: "BA", label: "BA" },
  { key: "CE", label: "CE" },
  { key: "DF", label: "DF" },
  { key: "ES", label: "ES" },
  { key: "GO", label: "GO" },
  { key: "MA", label: "MA" },
  { key: "MT", label: "MT" },
  { key: "MS", label: "MS" },
  { key: "MG", label: "MG" },
  { key: "PA", label: "PA" },
  { key: "PB", label: "PB" },
  { key: "PR", label: "PR" },
  { key: "PE", label: "PE" },
  { key: "PI", label: "PI" },
  { key: "RJ", label: "RJ" },
  { key: "RN", label: "RN" },
  { key: "RS", label: "RS" },
  { key: "RO", label: "RO" },
  { key: "RR", label: "RR" },
  { key: "SC", label: "SC" },
  { key: "SP", label: "SP" },
  { key: "SE", label: "SE" },
  { key: "TO", label: "TO" },
];

export function formatAsBRDateTime(
  dateString: string | null | undefined
): string {
  if (!dateString) return "";

  const date = new Date(dateString);

  const localDate = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );

  return localDate.toLocaleString("pt-BR", {
    timeZone: "America/Sao_Paulo",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
export const UF_OPTIONS = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

export function formatStandartRate(value: string): string {
  if (!value) return "";

  const numeric = value.replace(/[^\d]/g, "");

  if (!numeric) return "";

  const padded = numeric.padStart(3, "0");

  const integer = padded.slice(0, padded.length - 2);
  const decimal = padded.slice(-2);

  return `${parseInt(integer, 10)},${decimal}`;
}
